import React from 'react';
import { BedIcon, BrainIcon, HeartHandshakeIcon, HospitalIcon, MoonIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { images } from '../../data/images';
import { container } from '../../utils/styles';
import { SectionHeading } from '../shared/SectionHeading';
const options = [{
  icon: HospitalIcon,
  title: {
    en: 'Hospital-to-home transition',
    es: 'Transición del hospital a casa'
  },
  body: {
    en: 'Support in the first days and weeks home after surgery or a hospital stay.',
    es: 'Apoyo en los primeros días y semanas en casa después de una cirugía u hospitalización.'
  }
}, {
  icon: BrainIcon,
  title: {
    en: "Alzheimer's & dementia",
    es: 'Alzheimer y demencia'
  },
  body: {
    en: 'Calm, consistent routines and safety supervision for memory conditions.',
    es: 'Rutinas tranquilas y constantes y supervisión para condiciones de memoria.'
  }
}, {
  icon: MoonIcon,
  title: {
    en: 'Overnight care',
    es: 'Cuidado nocturno'
  },
  body: {
    en: 'Awake or sleeping overnight shifts for nighttime safety and wandering prevention.',
    es: 'Turnos nocturnos, despiertos o dormidos, para la seguridad y evitar la desorientación.'
  }
}, {
  icon: BedIcon,
  title: {
    en: '24-hour live-in care',
    es: 'Cuidado interno de 24 horas'
  },
  body: {
    en: 'Round-the-clock presence for advanced dementia or complex needs.',
    es: 'Presencia continua para demencia avanzada o necesidades complejas.'
  }
}, {
  icon: HeartHandshakeIcon,
  title: {
    en: 'End-of-life comfort care',
    es: 'Cuidado de confort al final de la vida'
  },
  body: {
    en: 'Gentle, dignified companionship alongside your hospice team.',
    es: 'Compañía amable y digna junto a tu equipo de hospicio.'
  }
}];
export function SpecializedCare() {
  const {
    t
  } = useLanguage();
  return <section className="bg-cream py-20 sm:py-24" aria-labelledby="specialized-heading" data-id="element-251" data-mp="3k5ei2kx9o9bu">
      <div className={`${container} grid gap-12 lg:grid-cols-12 lg:items-center lg:gap-16`} data-id="element-252" data-mp="3f6l30o2c0a9k">
        <div className="lg:col-span-7" data-id="element-253" data-mp="1j59jer1kmk94">
          <SectionHeading id="specialized-heading" title={t({
          en: 'Specialized Care Options',
          es: 'Opciones de Cuidado Especializado'
        })} intro={t({
          en: 'When needs grow more complex, your care plan grows with them.',
          es: 'Cuando las necesidades se vuelven más complejas, tu plan de cuidado crece con ellas.'
        })} data-id="element-254" data-mp="1j47yzvyo0leq" />
          <ul className="mt-10 grid gap-x-8 gap-y-7 sm:grid-cols-2" data-id="element-255" data-mp="107q97k3dmvl4">
            {options.map(o => {
            const Icon = o.icon;
            return <li key={o.title.en} className="flex gap-4" data-id="element-256" data-mp="1a2qhqa9iudog">
                  <Icon className="mt-1 h-6 w-6 shrink-0 text-brand" aria-hidden="true" data-id="element-257" data-mp="1e5eqyj25dmly" />
                  <div data-id="element-258" data-mp="2liyqitfjql8k">
                    <h3 className="font-sans text-lg font-semibold text-ink" data-id="element-259" data-mp="2ljhxxg7klr8c">{t(o.title)}</h3>
                    <p className="mt-1 leading-relaxed text-ink-soft" data-id="element-260" data-mp="2pk0rpft0x7d6">{t(o.body)}</p>
                  </div>
                </li>;
          })}
          </ul>
        </div>
        <div className="lg:col-span-5" data-id="element-261" data-mp="9vlf5mann57d">
          <img src={images.home.src} alt={t(images.home.alt)} loading="lazy" className="h-80 w-full rounded-2xl object-cover sm:h-[30rem]" data-id="element-262" data-mp="9wo77xjprdov" />
          <p className="mt-4 text-ink-soft" data-id="element-263" data-mp="52seb9ib4h0k">
            {t({
            en: 'Every plan includes a free home safety walkthrough: lighting, walkways, bathroom access, and fall risks.',
            es: 'Cada plan incluye una revisión gratuita de seguridad del hogar: iluminación, pasillos, acceso al baño y riesgos de caídas.'
          })}
          </p>
        </div>
      </div>
    </section>;
}